import type { TOC } from '@ember/component/template-only'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { AssessmentScoresHistory } from 'teacher-ui-client/components/giraffe/charts/assessment-scores/history'
import { AssessmentScoresAverages } from 'teacher-ui-client/components/giraffe/charts/assessment-scores/averages'
import RouteTemplate from 'ember-route-template'
import { t } from 'ember-intl'
import { array } from '@ember/helper'
import { not } from 'ember-truth-helpers'
import type ReporitngUiScopeMathsAssessmentScoresRoute from 'teacher-ui-client/reporting/ui-scope/maths/assessment-scores/route'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import { Precinct } from 'teacher-ui-client/utils/precincts'

interface Signature {
  model: ModelFor<ReporitngUiScopeMathsAssessmentScoresRoute>
}

export const ReportingUiScopeMathsAssessmentScoresPage: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.assessmentScores.maths"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.assessmentScoresAverages}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.maths.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.assessmentScoresAverages}}>
    {{#each @model.assessmentScoresAverages as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <AssessmentScoresAverages
          data-test-assessment-scores-averages
          @data={{gradeData}}
          @title={{t "reporting.chartTitles.assessmentScoresAverages.maths"}}
          @grade={{fullGradeName gradeData.grade_position}}
          @precinct={{Precinct.MS_LESSONS}}
          @tooltip={{t "reporting.tooltips.assessmentScoresAverages.maths"}}
        />
      </div>
    {{/each}}
    {{#if @model.assessmentScoresHistory}}
      <AssessmentScoresHistory
        data-test-assessment-scores-history
        @tooltip={{t "reporting.tooltips.assessmentScoresHistory.maths" htmlSafe=true}}
        @assessmentScoresHistoryData={{@model.assessmentScoresHistory}}
        @subco={{(isSubco)}}
        @students={{@model.scopedStudents}}
        @uiScope={{@model.uiScope.scope}}
        @product={{@model.product}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReportingUiScopeMathsAssessmentScoresPage)
